import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const ServiceLevelAgreement = () => {
  return (
    <>
      <SEO 
        title="Service Level Agreement (SLA) - Abacies Logiciels"
        description="Review Abacies Logiciels' Service Level Agreement outlining our commitment to service availability, performance standards, response times, and support guarantees for our clients."
        keywords="service level agreement, SLA, service guarantees, uptime guarantee, support SLA, service commitments"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Service Level Agreement
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Service Level Agreement page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Service Level Agreement. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceLevelAgreement;
